
import {promptMessage } from '@/api/dataHandling';
import XHeader from 'vux/src/components/x-header/index.vue'

import axios from 'axios';
export default {
data(){
return{
headerName:'',
list:[],
}
},
components: {
XHeader
},
mounted(){
this.$store.commit('updateLoadingStatus',{isLoading:true});
this.headerName = this.$route.query.headTitle.trim();
if(this.headerName == '移植前'){
this.categoryId = 305;

}else if(this.headerName == '移植后'){
this.categoryId = 306;

}else if(this.headerName == '取卵前'){
this.categoryId = 304;

}else if(this.headerName == '进周前'){
this.categoryId = 302;

}else if(this.headerName == '进周后'){
this.categoryId = 303;

}else if(this.headerName == '怀孕后'){
this.categoryId = 308;

}else if(this.headerName == '反复流产/失败'){
this.categoryId = 307;

}else if(this.headerName == '试管前'){
this.categoryId = 301;

}
axios.post('http://service.wh.jinxin-fertility.com:8093/cms/ms/cms/article/'+this.categoryId+'/getList.do?articleTypeStr=').then(response => {
if(response.data.resultCode == 'success'){
this.list = response.data.data;
this.$store.commit('updateLoadingStatus',{isLoading:false});
}else {
this.$store.commit('updateLoadingStatus',{isLoading:false});
promptMessage('提示',data.resultMsg)
}
}).catch(error => {
promptMessage('提示',error)
})
}
}



// WEBPACK FOOTER //
// ./src/project/testTubeEncyclopedia/TestTubeEncyclopediaList.vue